import React from 'react';

export default function NotFound() {
  return (
    <div style={{ padding: '2rem' }}>
      <p>Requested resource not found</p>
    </div>
  );
}
